import { faPen } from '@fortawesome/pro-regular-svg-icons'
import { Tooltip } from '@pinchenterprisesnpm/friday-ui'
import { EditIcon as EditIconStyled } from './edit-icon.style'

interface IEditIconProps {
  onEdit?: () => void
  isDisabled?: boolean
  disabledTooltipText?: string
}

export const EditIcon = ({ onEdit, isDisabled, disabledTooltipText }: IEditIconProps) => {
  if (isDisabled) {
    return (
      <Tooltip text={disabledTooltipText}>
        <EditIconStyled icon={faPen} isDisabled />
      </Tooltip>
    )
  }

  return <EditIconStyled icon={faPen} onClick={onEdit} />
}
